/**************************************************
 * Nombre:       Formulario_Totales.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircle,
    BadgeOutlined,
    CakeOutlined,
    Flag,
    Mail,
    ShoppingBagOutlined, ShoppingBag,
    SignpostOutlined,
    SmartphoneOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useContext, useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";
import {contexApp} from "../../App";
import {obtenerValorTotal} from "./Formulario_Lista_Productos";

const Formulario_Totales = ({...props}) => {
    const cData = useContext(contexApp)
    const [total, setTotal] = useState(0);
    const [valorCompra, setValorCompra] = useState(0);
    const [valorEnvio, setValorEnvio] = useState(0);

     const calcularEnvio = (entidad, valorCompra) => {

        let rutas = cData.rutas
        let indexRuta = rutas.findIndex((it) => it.nombre === entidad.provincia);
        let ruta = rutas[indexRuta];
        let peso = calcularPeso(entidad.productos)

        let valor = ruta.valor * peso

        if (valorCompra >= ruta.valorGratis) {
            return 0
        } else {
            return valor
        }

    }

    let calcularPeso = (productos) => {

        let peso = 0
        for (const prod of productos) {

            peso = peso + (parseInt(prod.cantidad) * parseInt(prod.peso))
        }

        return redondearArribaDecimal(peso / 1000);

    }

    const redondearArribaDecimal = (numero) => {
        const factor = Math.pow(10, 0);
        return Math.ceil(numero * factor) / factor;
    };


    useEffect(() => {

        let entidad = props.props.getValues()
        let valProductos = obtenerValorTotal(entidad.productos)
        setValorCompra(valProductos)

        let valEnvio = calcularEnvio(entidad, valProductos)
        setValorEnvio(valEnvio)
        props.props.setValue('valorEnvio', valEnvio)

    }, [props])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Valores Compra</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                    <ShoppingBagOutlined sx={{fill: theme.palette.primary.main, width: 150, height: 150}}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end',mt: 4}}>
                    <Typography sx={{fontSize: 20}}>Valor Compra:
                    <span style={{marginLeft: 10, fontWeight: 'bold'}} >
                        {formatoMoneda(valorCompra)}
                    </span>
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -2}}>
                    <Typography sx={{fontSize: 20}}>Valor Envio:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}} >
                        {formatoMoneda(valorEnvio)}
                    </span>
                    </Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Totales